import { render, staticRenderFns } from "./SessionPage.vue?vue&type=template&id=b30c6880&"
import script from "./SessionPage.vue?vue&type=script&lang=js&"
export * from "./SessionPage.vue?vue&type=script&lang=js&"
import style0 from "./SessionPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
